import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";

function e(e, t, n) {
  void 0 === n && (n = {});
  var r = Object.assign({}, n, {
    g: e,
    email: t
  }),
      s = Object.keys(r).reduce(function (e, t) {
    return e.append(t, r[t]), e;
  }, new URLSearchParams());
  return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
    method: "POST",
    headers: {
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
    },
    body: s
  }).then(function (e) {
    return e.json();
  });
}

export { e as subscribe };